import React from 'react'
import env from './../environments/environment'
import { TrackJS } from 'trackjs'

export class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    if (errorInfo && errorInfo.componentStack) {
      if (!env?.env || (env?.env && ['beta', 'production'].indexOf(env.env) < 0))
        console.error(errorInfo.componentStack)
    }
    if (window.TrackJS && env?.integrations?.track_js) TrackJS.track(error)

    // Third-party widgets (e.g. Social Intents chat) inject full-viewport
    // iframes into <body> at max z-index. Disable their pointer capture so
    // the fallback reload button stays clickable. A MutationObserver handles
    // widgets that inject or reset asynchronously.
    const disableOverlays = () => {
      document.querySelectorAll('body > iframe').forEach(el => {
        el.style.setProperty('pointer-events', 'none', 'important')
      })
    }
    disableOverlays()
    this._overlayObserver = new MutationObserver(disableOverlays)
    this._overlayObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style'],
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '24px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            color: '#333',
            textAlign: 'center',
            position: 'fixed',
            inset: 0,
            zIndex: 2147483647,
            backgroundColor: '#fff',
          }}
        >
          <h1 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '12px' }}>Something went wrong</h1>
          <p style={{ fontSize: '16px', color: '#666', marginBottom: '24px', maxWidth: '420px' }}>
            An unexpected error occurred. Please reload the page to continue.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 24px',
              fontSize: '14px',
              fontWeight: 500,
              color: '#fff',
              backgroundColor: '#1976d2',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Reload Page
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
